"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var fuse_js_1 = __importDefault(require("fuse.js"));
var React = __importStar(require("react"));
var formatResults_1 = require("./formatResults");
var FuzzyHighlighter = (function (_super) {
    __extends(FuzzyHighlighter, _super);
    function FuzzyHighlighter() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            results: [],
            cache: {},
            info: { timing: 0 },
        };
        return _this;
    }
    FuzzyHighlighter.prototype.componentDidMount = function () {
        var _a = this.props, data = _a.data, options = _a.options;
        this.fuse = new fuse_js_1.default(data, __assign(__assign({}, options), { shouldSort: true, includeMatches: true }));
        this.search();
    };
    FuzzyHighlighter.prototype.componentDidUpdate = function (prevProps) {
        if (prevProps.query !== this.props.query) {
            this.search();
        }
        if (prevProps.data !== this.props.data) {
            this.fuse.setCollection(this.props.data);
            this.setState({ cache: {} }, this.search);
        }
    };
    FuzzyHighlighter.prototype.render = function () {
        var children = this.props.children;
        var _a = this.state, results = _a.results, info = _a.info;
        if (children) {
            return children({
                results: results,
                formattedResults: formatResults_1.formatResults(results),
                timing: info.timing,
            });
        }
        return null;
    };
    FuzzyHighlighter.prototype.search = function () {
        var _a;
        var query = this.props.query;
        var cache = this.state.cache;
        if (Object(cache).hasOwnProperty(query)) {
            return this.setState({ results: cache[query], info: { timing: 0 } });
        }
        var start = window.performance.now();
        var search = this.fuse.search(query);
        var end = window.performance.now();
        var results = search;
        var timing = parseFloat((end - start).toFixed(3));
        this.setState({
            results: results,
            cache: __assign(__assign({}, cache), (_a = {}, _a[query] = results, _a)),
            info: { timing: timing },
        });
    };
    return FuzzyHighlighter;
}(React.Component));
exports.default = FuzzyHighlighter;
